module.exports = __webpack_public_path__ + "static/img/NBA2K19LOGO.f21993f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/NBA2K19/NBA2K19LOGO.png
// module id = +j8T
// module chunks = 0